module.exports = __webpack_public_path__ + "static/media/md-share-alt.aed8ca41.svg";